import { AutogenLayoutLinkTender } from "./autogen/AutogenLayoutLinkTender";


export class LinkTender extends AutogenLayoutLinkTender {

}
